module.exports = __webpack_public_path__ + "img/undraw_diet.60f663e9.svg";